import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Brand";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (admin) navigate("/admin", { replace: true });
  }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      await login(data.token, data.user);
      toast.success("Signed in.");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  const input =
    "w-full bg-[#0d120e] border border-[#232f25] rounded-md px-3.5 py-2.5 text-sm text-[#f4f7f4] placeholder:text-[#69776b] outline-none focus:border-[#8CE63C] focus:ring-2 focus:ring-[#8CE63C]/20";

  return (
    <div className="min-h-screen erp-grid-bg flex flex-col items-center justify-center px-4">
      <Link to="/" className="mb-8">
        <Brand size="lg" showTagline />
      </Link>
      <div className="erp-fade-up w-full max-w-sm rounded-2xl border border-[#232f25] bg-[#111712] p-8">
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#8CE63C]">
          Secure Access
        </span>
        <h1 className="font-display text-2xl font-black text-white uppercase tracking-tight mt-2">
          Dealer Admin Portal
        </h1>
        <form onSubmit={submit} className="space-y-4 mt-6">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wide text-[#9EABA0] mb-1.5">
              Email
            </label>
            <input
              data-testid="admin-login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={input}
              placeholder="you@company.com"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wide text-[#9EABA0] mb-1.5">
              Password
            </label>
            <input
              data-testid="admin-login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={input}
              placeholder="••••••••"
              required
            />
          </div>
          <button
            type="submit"
            data-testid="admin-login-submit-button"
            disabled={loading}
            className="w-full px-6 py-3 rounded-md bg-[#8CE63C] text-[#080b08] text-sm font-black uppercase tracking-wider hover:bg-[#9df04f] transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
      <Link to="/" className="mt-6 text-xs text-[#69776b] hover:text-[#8CE63C] transition-colors">
        ← Back to Dealer Application
      </Link>
    </div>
  );
}
